import Vue from 'vue'

Vue.directive('feature', {
  bind(el,binding,vNode){
    el.style.display = 'none'
    if(global.gApp.$store.state.feature.keys.some(ele => ele == binding.value)){
      el.style.display = 'inline-block'
    }
  }
})
